<template>
  <div>
    <div class="statistical" style="margin-top: 10px">
      <statistical style="width: 340px" title="本日订单" prefix="" :color="headerStyle.day" :object="countHeader.today"/>
      <statistical style="width: 340px" title="昨日订单" prefix="" :color="headerStyle.lastDay" :object="countHeader.yesterday"/>
      <statistical style="width: 340px" title="本月订单" prefix="" :color="headerStyle.mouth" :object="countHeader.month"/>
      <statistical style="width: 340px" title="本年订单" prefix="" :color="headerStyle.year" :object="countHeader.year"/>
    </div>
    <div class="statistical stat-bottom" style="margin-top: 30px;">
      <el-card shadow="always" v-loading="pieChartLoading" class="stat-card">
        <div class="stat-card__head">
          <h3 class="stat-card__title">订单金额</h3>
          <span class="stat-card__total">合计：<b>{{ formatMoney(pieTotal) }}</b></span>
        </div>
        <div class="stat-card__filter">
          <select-area size="small" :multiple-status="true" @areaListId="getPieArea" @Flag="getPieFlag"/>
          <el-select style="width: 130px" clearable v-model="pieChart.type" placeholder="收款类型" size="small">
            <el-option
                v-for="item in tradingType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
          <el-date-picker
              style="width: 230px"
              size="small"
              v-model="pieChartDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          >
          </el-date-picker>
          <el-tooltip content="全屏">
            <span class="stat-card__full el-icon-rank" @click="handleFullScreen"></span>
          </el-tooltip>
        </div>
        <bread-view style="width: 100%; height: 380px;" v-on:detailed="detailed" :data="pieChartData.data" :data-info="pieChartData.info" :money="true"/>
      </el-card>
      <el-card shadow="always" v-loading="histogramLoading" class="stat-card">
        <div class="stat-card__head">
          <h3 class="stat-card__title">业绩排名</h3>
          <span class="stat-card__total">合计：<b>{{ formatMoney(histogramTotal) }}</b></span>
        </div>
        <div class="stat-card__filter">
          <select-area size="small" :multiple-status="true" @areaListId="getAreaListId" @Flag="getFlag"/>
          <el-date-picker
              style="width: 230px"
              size="small"
              v-model="histogramDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          >
          </el-date-picker>
          <el-tooltip content="全屏">
            <span class="stat-card__full el-icon-rank" @click="handleFullScreen"></span>
          </el-tooltip>
        </div>
        <pillars-view style="width: 100%; height: 380px;" v-on:histogramDetailed="histogramDetailed" :series="histogramData" :project="histogramProject.name" :money="true"/>
      </el-card>
    </div>
  </div>
</template>

<script>
import PillarsView from "@/views/statistical/component/PillarsView";
import BreadView from "@/views/statistical/component/BreadView";
import Statistical from "@/views/statistical/component/Statistical";
import {orderHeader, orderLeft,CoachPerformanceHistogramSummary} from "@/api/count";
import selectArea from "../../components/SelectArea";
import SelectArea from "../../components/SelectArea";
export default {
  props:{
    selectArea
  },
  name: "Console",
  components: {SelectArea, BreadView, Statistical,PillarsView,},
  data() {
    return {
      sysStudentType:localStorage.getItem('studentType'),
      countHeader: {},
      headerStyle:{
        day:{
          background: '#ECF5FF',
          color: '#409EFF',
          one:'el-icon-s-promotion',
          two:'iconfont icon-qian4'
        },
        lastDay:{
          background: '#F0F9EB',
          color: '#67C23A',
          one:'el-icon-s-promotion',
          two:'iconfont icon-qian4'
        },
        mouth:{
          background: '#FDF6EC',
          color: '#E6A23C',
          one:'el-icon-s-promotion',
          two:'iconfont icon-qian4'
        },
        year:{
          background: '#FEF0F0',
          color: '#F56C6C',
          one:'el-icon-s-promotion',
          two:'iconfont icon-qian4'
        }
      },
      tradingType:[{value:1,label:"订单"},{value:4,label:"器材"},{value:3,label:"定金"}],

      pieChartLoading:false,
      pieChartDate:"",
      pieChart:{
        endDate:"",
        regionId:null,
        regionIds:null,
        startDate:"",
        type:"",
        flag:null
      },
      pieChartData: {info: {type: "order", location: 'left', center: ['60%', '50%']}, data: []},

      histogramDate:"",
      regionList:[],
      regionId:[],
      histogram:{
        endDate:"",
        regionId:null,
        startDate:"",
      },//柱状图筛选条件
      histogramData: [],
      histogramProject:{},
      histogramLoading:false,
      series: [{data: [40, 50, 100], type: "bar"}],
    }
  },
  computed:{
    websocket() {
      return this.$store.state.webSocket.notifyObject;//这里返回vuex的state里的websocket数据
    },
    //左侧饼图（订单金额）合计
    pieTotal() {
      return (this.pieChartData.data || []).reduce((sum, item) => sum + (Number(item.value) || 0), 0);
    },
    //右侧柱状图（业绩排名）合计
    histogramTotal() {
      const first = this.histogramData && this.histogramData[0];
      const arr = (first && Array.isArray(first.data)) ? first.data : [];
      return arr.reduce((sum, v) => sum + (Number(v) || 0), 0);
    },
  },
  created: function () {
    this.getHeaderStatistical();
    this.getLeftStatistical();
    this.getCourseHistogramSummary();

  },
  methods: {
    getFlag(val){
      this.histogram.flag = val
      this.getCourseHistogramSummary();
    },
    //左侧-区域类型(flag)变化：中招/少年/高考/幼儿/全部
    getPieFlag(val){
      this.pieChart.flag = val;
      this.getLeftStatistical();
    },
    //左侧-可视区域/校区变化（多选：val 为 area id 数组；清空时为空数组）
    getPieArea(val){
      if (Array.isArray(val)) {
        this.pieChart.regionIds = val.length ? val : null;
        this.pieChart.regionId = null;
      } else {
        this.pieChart.regionIds = null;
        this.pieChart.regionId = val;
      }
      this.getLeftStatistical();
    },
    //金额展示：千分位 + ¥
    formatMoney(v){
      if (v === null || v === undefined || v === '') return '0';
      const n = Number(v);
      return isNaN(n) ? v : '¥ ' + n.toLocaleString('zh-CN');
    },
    //右侧-可视区域/校区变化（多选：val 为 area id 数组；清空时为空数组）
    getAreaListId(val){
      if (Array.isArray(val)) {
        this.histogram.areaList = val.length ? val : null;
      } else {
        this.histogram.areaList = val ? [val] : null;
      }
      this.getCourseHistogramSummary();
    },
    //饼状图点击事件（下钻：切回单节点，避免与多选 regionIds 冲突）
    detailed(val){
      this.pieChart.regionIds=null;
      this.pieChart.regionId=val.id;
      this.getLeftStatistical();
    },
    // 获取头部数据
    getHeaderStatistical(){
      orderHeader().then(res => {
        if (res.code == 200) {
          this.countHeader = res.data
        } else {
          this.$message.error("获取顶部统计数据失败");
        }
      })
    },
    //获取左边饼状图数据
    getLeftStatistical(){
      this.pieChartLoading=true;
      orderLeft(this.pieChart).then(val=>{
        this.pieChartLoading=false;
        if (val.code == 200) {
          this.pieChartData.data = val.data

        } else {
          this.$message.error("获取饼状图统计数据失败");
        }
      })
    },
    //获取右边柱状图数据
    getCourseHistogramSummary(){
      this.histogramLoading=true;
      CoachPerformanceHistogramSummary(this.histogram).then(val=>{
        // console.log(val)
        this.histogramLoading=false;
        if (val.code == 200) {

          this.histogramData = [{data: val.data.valueList || [], type: "bar"}]
          this.histogramProject = {name: val.data.nameList || []}
        } else {
          this.$message.error("获取柱状图统计数据失败");
        }
      })
    },
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    dateFormat(val) {
      var date = new Date(val)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      const time = y + '-' + m + '-' + d
      return time
    },

  },
  watch:{
    //监听用户选择时间完成以后进行查询
    pieChartDate(){
      if (this.pieChartDate!=null && this.pieChartDate!="" && this.pieChartDate.length>0){
        this.pieChart.startDate= this.dateFormat(this.pieChartDate[0]);
        this.pieChart.endDate= this.dateFormat(this.pieChartDate[1]);
      }else {
        this.pieChart.startDate="";
        this.pieChart.endDate="";
      }
      this.getLeftStatistical();
    },
    //监听用户选择类型完成以后进行查询
    'pieChart.type': {
      handler() {
        this.getLeftStatistical();
      },
      deep: true
    },
    regionId:{
      handler() {
        let regionId="";
        for (const item of this.regionId) {
          regionId=regionId+item+","
        }
        this.histogram.regionId=regionId;
        this.getCourseHistogramSummary();
      },
      deep: true
    },
    //监听用户选择柱状图时间完成以后进行查询
    histogramDate(){
      if (this.histogramDate!=null && this.histogramDate!="" && this.histogramDate.length>0){
        this.histogram.startDate= this.dateFormat(this.histogramDate[0]);
        this.histogram.endDate= this.dateFormat(this.histogramDate[1]);
      }else {
        this.histogram.startDate="";
        this.histogram.endDate="";
      }
      this.getCourseHistogramSummary();
    },
    websocket:{
      handler(newVal) {
        // console.log(newVal, oval);//nval改变后的新数据，oval改变前的旧数据
        if (newVal.api=="order"){
          this.getHeaderStatistical();
          this.getLeftStatistical();
          this.getCourseHistogramSummary();
        }
      },
      deep: true, // 深度监听
      immediate: true,//立即执行
    }
  }

}
</script>

<style>
.ordersPicker {
  display: flex;
  justify-content: flex-end;
}

.statistical {
  display: flex;
  justify-content: space-between;

}
</style>
<style scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}
.el-dialog {
  margin: 0 auto;
  height: 100%;
  overflow: hidden;
}

/* ---- 下方两块统计卡片：整体视觉与条理 ---- */
.statistical.stat-bottom {
  gap: 16px;
  align-items: stretch;
}
.stat-card {
  flex: 1 1 0;
  min-width: 0;
  border-radius: 12px;
}
.stat-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.stat-card__title {
  margin: 0;
  line-height: 1.4;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.stat-card__title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 15px;
  margin-right: 8px;
  border-radius: 2px;
  vertical-align: -2px;
  background: linear-gradient(180deg, #7b5cff, #a78bfa);
}
.stat-card__total {
  font-size: 13px;
  color: #909399;
}
.stat-card__total b {
  margin-left: 2px;
  font-size: 15px;
  color: #7b5cff;
}
.stat-card__filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 6px;
}
.stat-card__filter > * {
  margin-right: 10px;
  margin-bottom: 6px;
}
.stat-card__full {
  cursor: pointer;
  color: #909399;
  font-size: 17px;
  padding: 4px;
}
.stat-card__full:hover {
  color: #7b5cff;
}
</style>
<style lang="scss">
.el-popover.my-el-popover {
  width: 20px;
}
.el-cascader__tags {
  display: inline-flex;
  margin-right: 60px;
  flex-wrap: nowrap;
}
</style>
